module.exports = __webpack_public_path__ + "ab2283a629d85b70b1cedb514b4ef0d0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Swift-Icons.ttf?-v0i0qt
// module id = 1486
// module chunks = 0